import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Info: Content levará padding e Wrapper será apenas o box
export interface IBoxSectionContainerProps {
  level?: 'content' | 'wrapper';
}

export const BoxSectionContainer = styled.section<IBoxSectionContainerProps>`
  background-color: ${({ theme }) => theme.palette?.brand.neutral.base};
  padding: 2rem;
  min-height: 295px;
  position: relative;
  border: 1px solid #EDEDED;
  border-radius: 10px;

    ${({ level }) =>
      level === 'wrapper' &&
      css`
        border-radius: 0px 0px 10px 10px !important;
    `}

  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.tablet + 'px'}){
      padding: 20px;
      border: none;
  };
  
`;
